import { boolean } from 'boolean';

export default function boolToTextFilter(value: any): string {
  return boolean(value) ? 'Да' : 'Нет';
}
